import { useAppConstantsContext } from '@/context/AppConstants';
import { VehicleOwnershipHistoryCard } from '@/reports/sections/VehicleOwnershipHistory/VehicleOwnershipHistoryCard';
import { EmptyVehicleSectionDisclaimer } from '@/reports/shared/ReportSection/EmptyVehicleSectionDisclaimer/EmptyVehicleSectionDisclaimer';
import { ReportSection } from '@/reports/shared/ReportSection/ReportSection';
import { HowItWorksCTA } from '@/reports/shared/ReportSection/components';
import { AutomobileOwnershipHistories } from '@/reports/types/vehicles';
import { Stack, Text } from '@/theme/index';

const HowItWorks = () => {
  const {
    data: { brandName },
  } = useAppConstantsContext();

  return (
    <HowItWorksCTA
      content={
        <Text variant="body2">
          The Ownership History section helps provide valuable insight into a
          vehicle&apos;s past. {brandName} does not, however, disclose the names
          or any personal information of previous owners in order to protect
          their privacy and in compliance with the Driver&apos;s Privacy
          Protection Act (DPPA).
        </Text>
      }
    />
  );
};

interface VehicleOwnershipHistoryProps {
  vehicleOwnershipHistories: AutomobileOwnershipHistories;
}

export function VehicleOwnershipHistory({
  vehicleOwnershipHistories,
}: VehicleOwnershipHistoryProps) {
  return (
    <ReportSection
      supertitleText="Title History"
      showTopBar
      title="Ownership History"
      hasContent={vehicleOwnershipHistories?.length > 0}
      sectionId="vehicle-ownership-history"
      howItWorks={<HowItWorks />}
      customEmptyText={
        <EmptyVehicleSectionDisclaimer title="ownership history" />
      }
    >
      <Stack
        direction={{ md: 'row', sm: 'column' }}
        display="flex"
        flexWrap="wrap"
        columnGap={2}
        rowGap={2}
      >
        {vehicleOwnershipHistories?.map((record, index) => {
          return (
            <VehicleOwnershipHistoryCard
              key={`${index}-vehicle-ownership-history-card`}
              position={index + 1}
              vehicleOwnershipHistory={record}
            />
          );
        })}
      </Stack>
      <HowItWorks />
    </ReportSection>
  );
}
